(function () {
  'use strict'

  require('./scss/app.scss')
  require('./scss/app-event-dynamic.scss')

  const MODULE_NAME = 'thismoment.card.component.appEventDynamic'
  const templateUrl = require('./tpl/app-event-dynamic.html')
  const calendarLink = require('calendar-link')

  require('angular')
    .module(MODULE_NAME, [
    ])
    .config(appEventDynamicConfig)
    .component('thismomentAppEventDynamic', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appEventDynamicController
    })

  appEventDynamicConfig.$inject = ['$compileProvider']
  function appEventDynamicConfig ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|http|data):/)
  }

  appEventDynamicController.$inject = ['SdkConfig']
  function appEventDynamicController (SdkConfig) {
    var vm = this

    vm.$onInit = vcardDynamicInit
    vm.isMobile = SdkConfig.get('is_mobile')

    function vcardDynamicInit () {
      const ecard = vm.item.app.user.ecard
      const calEvent = {
        title: ecard.title,
        description: ecard.description,
        start: ecard.date_time_start,
        end: ecard.date_time_end
      }

      if (angular.isDefined(ecard.location)) {
        calEvent.location = ecard.location
      }
      if (angular.isDefined(ecard.url)) {
        calEvent.url = ecard.url
      }

      vm.gCalLink = calendarLink.google(calEvent)
      vm.iCalLink = calendarLink.ics(calEvent)
      vm.outlookLink = calendarLink.outlook(calEvent)

      if (angular.isDefined(vm.item.app.language) && vm.item.app.language === 'zh-hk') {
        vm.addToCalLabel = '添加到日历'
      } else {
        vm.addToCalLabel = 'Add to calendar'
      }

      vm.trackEvent = vm.parent.trackEvent
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-eventDynamic.js